import React, {useState} from 'react'
import  {Avatar, Button, Paper, Grid, Typography, Container, TextField, InputAdornment} from '@material-ui/core'
import LoadingButton from '@mui/lab/LoadingButton';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import useStyles from './styles';
import Input from './Input';
import {GoogleLogin} from 'react-google-login';
import Icon from './icon'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {signin, signup} from '../../actions/auth'
const initalState = {firstName: '', lastName: '', email: '', password: '', confirmPassword: ''};


const Auth = () => {

    const classes = useStyles();
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const [isSignup, setisSignup] = useState(false)
    const history = useHistory();
    const [formData, setFormData] = useState(initalState);
    const [loading, setLoading] = useState(false);



    const handleSubmit = (e) => {
        e.preventDefault();
        if(isSignup){
            dispatch(signup(formData, history));
        }else {
            dispatch(signin(formData, history));
        }
    };
    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
        
    };
    const handleShowPassword = () => setShowPassword((prev) => !prev);
    
    const switchMode = () => {
        setisSignup((prev) => !prev);
        setShowPassword(false);
    };

    const googleSuccess = async (res) => {
        const result = res?.profileObj;
        const token = res?.tokenId;

        try {
            dispatch({ type: 'AUTH', data: {result, token}});
            history.push('/');
        } catch (error) {
            console.log(error)
        }

    };

    const googleFailure = (error) => {
        console.log(error)
        console.log("Google Sign in was unsuccessful. Try again later.");
    };
    
    


    
    

    return (
        <Container component="main" maxWidth="xs">
            <Paper className={classes.paper} elevation={3}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography variant="h5">{isSignup ? 'Sign Up': 'Sign in'}</Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {
                            isSignup && (
                                <>
                                    <Input name="firstName" label="First Name" handleChange={handleChange} autoFocus half />
                                    <Input name="lastName" label="Last Name" handleChange={handleChange} half />
                                </>
                            )
                        }
                        <Input name="email" label="Email Adress" handleChange={handleChange} type="email"/>
                        <Input name="password" label="password" handleChange={handleChange} type={showPassword ? "text": "password"} handleShowPassword={handleShowPassword}/>
                        { isSignup  && <Input name="confirmPassword" label="Repeat Password" handleChange={handleChange} type="password"/>}
                        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                            {isSignup ? 'Sign Up' : 'Sign In'}
                        </Button>
                        <GoogleLogin 
                            clientId="34532495608-c0t2gq295cm98rjr42br275a1ug1k6eh.apps.googleusercontent.com"
                            render={(renderProps) => (
                                <Button className={classes.googleButton} color="primary" fullWidth onClick={renderProps.onClick} disabled={renderProps.disabled} startIcon={<Icon />} variant="contained"> Google Sign in</Button>
                            )}
                            onSuccess={googleSuccess}
                            onFailure={googleFailure}
                            cookiePolicy="single_host_origin"
                        />
                        <Grid container justifyContent="flex-end">
                            <Button onClick={switchMode}>
                                {isSignup ? 'Already have an account? Sign in': "Don't have an account? Sign Up"}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

        </Container>
    )
}

export default Auth
